module.exports = __webpack_public_path__ + "static/img/2.30b5d40.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/17/sp/2.png
// module id = muzq
// module chunks = 0